import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "weddingDate",
  class: "flex flex-col md:flex-row gap-6 p-8 items-center justify-center bg-[#F9F6F2]"
}
const _hoisted_2 = {
  class: "flex flex-col bg-white shadow-xl rounded-lg p-6 mb-4 w-full max-w-md i",
  "data-aos": "slide-up",
  "data-aos-duration": "1000"
}
const _hoisted_3 = {
  class: "flex items-center mb-2",
  "data-aos": "fade-up",
  "data-aos-delay": "400"
}
const _hoisted_4 = {
  class: "flex items-center mb-2",
  "data-aos": "fade-up",
  "data-aos-delay": "600"
}
const _hoisted_5 = {
  class: "flex items-center mb-2",
  "data-aos": "fade-up",
  "data-aos-delay": "800"
}
const _hoisted_6 = {
  href: "https://maps.app.goo.gl/UaZ7sBnb9BNRoTNT9",
  target: "_blank",
  class: "mt-4 inline-block bg-blue-900 w-fit text-white py-2 px-4 rounded hover:bg-blue-500 transition duration-300",
  "data-aos": "fade-up",
  "data-aos-delay": "1000"
}
const _hoisted_7 = {
  class: "flex flex-col bg-white shadow-xl rounded-lg p-6 mb-4 w-full max-w-md i",
  "data-aos": "slide-up",
  "data-aos-duration": "1000"
}
const _hoisted_8 = {
  class: "flex items-center mb-2",
  "data-aos": "fade-up",
  "data-aos-delay": "400"
}
const _hoisted_9 = {
  class: "flex items-center mb-2",
  "data-aos": "fade-up",
  "data-aos-delay": "600"
}
const _hoisted_10 = {
  class: "flex items-center mb-2",
  "data-aos": "fade-up",
  "data-aos-delay": "800"
}
const _hoisted_11 = {
  href: "https://maps.app.goo.gl/Hp17XTSLrDsJh5G77",
  target: "_blank",
  class: "mt-4 inline-block bg-blue-900 w-fit text-white py-2 px-4 rounded hover:bg-blue-500 transition duration-300",
  "data-aos": "fade-up",
  "data-aos-delay": "1000"
}
const _hoisted_12 = {
  class: "flex flex-col bg-white shadow-xl rounded-lg p-6 w-full max-w-md transition-transform transform hover:scale-105",
  "data-aos": "slide-up",
  "data-aos-duration": "1000"
}
const _hoisted_13 = {
  class: "flex items-center mb-2",
  "data-aos": "fade-up",
  "data-aos-delay": "400"
}
const _hoisted_14 = {
  class: "flex items-center mb-2",
  "data-aos": "fade-up",
  "data-aos-delay": "600"
}
const _hoisted_15 = {
  class: "flex items-center mb-2",
  "data-aos": "fade-up",
  "data-aos-delay": "800"
}
const _hoisted_16 = {
  href: "https://maps.app.goo.gl/Hp17XTSLrDsJh5G77",
  target: "_blank",
  class: "w-fit mt-4 inline-block bg-blue-900 text-white py-2 px-4 rounded hover:bg-blue-500 transition duration-300",
  "data-aos": "fade-up",
  "data-aos-delay": "1000"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("h2", {
        class: "text-3xl font-bold text-center mb-4 text-blue-900",
        "data-aos": "fade-up",
        "data-aos-delay": "200"
      }, " Tasyakuran Mempelai Pria ", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_font_awesome_icon, {
          icon: ['fas', 'calendar'],
          class: "text-blue-900 mr-2"
        }),
        _cache[0] || (_cache[0] = _createElementVNode("span", { class: "font-merriweather text-md" }, "Tanggal:Selasa, 24 Juni 2025", -1))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_font_awesome_icon, {
          icon: ['fas', 'clock'],
          class: "text-blue-900 mr-2"
        }),
        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "font-merriweather text-md" }, "Waktu: 10:00 WIB - Selesai", -1))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_font_awesome_icon, {
          icon: ['fas', 'map-marker-alt'],
          class: "text-blue-900 mr-2"
        }),
        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "font-merriweather text-md" }, "Lokasi: Dsn Panyeretan RT 01/09, Desa Sidamukti, Kec. Patimuan ", -1))
      ]),
      _createElementVNode("a", _hoisted_6, [
        _createVNode(_component_font_awesome_icon, {
          icon: ['fas', 'map-marker-alt'],
          class: "text-white mr-2"
        }),
        _cache[3] || (_cache[3] = _createTextVNode(" Petunjuk Lokasi "))
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _cache[9] || (_cache[9] = _createElementVNode("h2", {
        class: "text-3xl font-bold text-center mb-4 text-blue-900",
        "data-aos": "fade-up",
        "data-aos-delay": "200"
      }, " Akad Nikah ", -1)),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_font_awesome_icon, {
          icon: ['fas', 'calendar'],
          class: "text-blue-900 mr-2"
        }),
        _cache[5] || (_cache[5] = _createElementVNode("span", { class: "font-merriweather text-md" }, "Tanggal: Jum'at, 27 Juni 2025 ", -1))
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_font_awesome_icon, {
          icon: ['fas', 'clock'],
          class: "text-blue-900 mr-2"
        }),
        _cache[6] || (_cache[6] = _createElementVNode("span", { class: "font-merriweather text-md" }, "Waktu: 08.00 WIB - 10.00 WIB", -1))
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_font_awesome_icon, {
          icon: ['fas', 'map-marker-alt'],
          class: "text-blue-900 mr-2"
        }),
        _cache[7] || (_cache[7] = _createElementVNode("span", { class: "font-merriweather text-md" }, "Lokasi: Kediaman Mempelai Wanita", -1))
      ]),
      _createElementVNode("a", _hoisted_11, [
        _createVNode(_component_font_awesome_icon, {
          icon: ['fas', 'map-marker-alt'],
          class: "text-white mr-2"
        }),
        _cache[8] || (_cache[8] = _createTextVNode(" Petunjuk Lokasi "))
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _cache[14] || (_cache[14] = _createElementVNode("h2", {
        class: "text-3xl font-bold text-center mb-4 text-blue-900",
        "data-aos": "fade-up",
        "data-aos-delay": "200"
      }, " Resepsi ", -1)),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_font_awesome_icon, {
          icon: ['fas', 'calendar'],
          class: "text-blue-900 mr-2"
        }),
        _cache[10] || (_cache[10] = _createElementVNode("span", { class: "font-merriweather text-md" }, "Tanggal: Jum'at, 27 Juni 2025", -1))
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_font_awesome_icon, {
          icon: ['fas', 'clock'],
          class: "text-blue-900 mr-2"
        }),
        _cache[11] || (_cache[11] = _createElementVNode("span", { class: "font-merriweather text-md" }, "Waktu: 10.00 WIB - Selesai", -1))
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_font_awesome_icon, {
          icon: ['fas', 'map-marker-alt'],
          class: "text-blue-900 mr-2"
        }),
        _cache[12] || (_cache[12] = _createElementVNode("span", { class: "font-merriweather text-md" }, "Lokasi: Jl Putat Raya RT 04/04, Desa Kamulyan, Kec. Bantarsari", -1))
      ]),
      _createElementVNode("a", _hoisted_16, [
        _createVNode(_component_font_awesome_icon, {
          icon: ['fas', 'map-marker-alt'],
          class: "text-white mr-2"
        }),
        _cache[13] || (_cache[13] = _createTextVNode(" Petunjuk Lokasi "))
      ])
    ])
  ]))
}